// all images imported from images directory
/* 
fiky-web
*/
import product_01_image_01 from "../images/1.jpeg";
import product_01_image_02 from "../images/2.jpeg";
import product_01_image_03 from "../images/3.jpeg";
import product_01_image_04 from "../images/6.jpeg";
import product_01_image_05 from "../images/12.png";
import product_01_image_06 from "../images/13.jpg";
import product_01_image_07 from "../images/14.jpg";
import product_01_image_08 from "../images/15.jpg";
import product_01_image_09 from "../images/sosis.png";
import product_01_image_10 from "../images/nugget.png";

import product_02_image_01 from "../images/11.jpg";
import product_02_image_02 from "../images/5.jpeg";
import product_02_image_03 from "../images/aqua.png";
import product_02_image_04 from "../images/sierra.jpeg";
import product_02_image_05 from "../images/gooday.png";
import product_02_image_06 from "../images/kapal.jpg";
import product_02_image_07 from "../images/abc.png";
import product_02_image_08 from "../images/latte.png";
import product_02_image_09 from "../images/capu.jpg";
import product_02_image_10 from "../images/energen.png";
import product_02_image_11 from "../images/jahe.jpg";

import product_06_image_01 from "../images/kroket.jpeg";
import product_06_image_02 from "../images/lumpia.jpg";

const products = [
  {
    id: "01",
    title: "Nasi Goreng",
    price: 10.000,
    image01: product_01_image_01,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "02",
    title: "Mie Goreng Double + Telor",
    price: 12.000,
    image01: product_01_image_02,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },

  {
    id: "03",
    title: "Nasi Ayam Goreng",
    price: 15.000,
    image01: product_01_image_03,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },

  {
    id: "04",
    title: "Mie Rebus Double + Telor",
    price: 12.000,
    image01: product_01_image_04,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "05",
    title: "Mie Goreng",
    price: 8.000,
    image01: product_01_image_05,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "06",
    title: "Mie Rebus",
    price: 8.000,
    image01: product_01_image_06,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "07",
    title: "Nasi Saja",
    price: 3.000,
    image01: product_01_image_07,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "08",
    title: "Nasi Telor",
    price: 10.000,
    image01: product_01_image_08,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "09",
    title: "Sosis (1 saja)",
    price: 3.000,
    image01: product_01_image_09,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "10",
    title: "Nugget (1 saja)",
    price: 3.000,
    image01: product_01_image_10,
    category: "Food",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },

  {
    id: "11",
    title: "Teh Pucuk",
    price: 3.500,
    image01: product_02_image_01,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },

  {
    id: "12",
    title: "Es Nutrisari (Nurdin)",
    price: 3.000,
    image01: product_02_image_02,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "13",
    title: "Aqua Botol",
    price: 3.000,
    image01: product_02_image_03,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "14",
    title: "Sierra Botol",
    price: 2.000,
    image01: product_02_image_04,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "15",
    title: "Kopi Good Day",
    price: 3.500,
    image01: product_02_image_05,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "16",
    title: "Kopi Kapal Api",
    price: 3.000,
    image01: product_02_image_06,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "17",
    title: "Kopi ABC Susu",
    price: 3.000,
    image01: product_02_image_07,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "18",
    title: "Kopi Creamy Latte",
    price: 3.000,
    image01: product_02_image_08,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "19",
    title: "Kopi Capuccino",
    price: 3.000,
    image01: product_02_image_09,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "20",
    title: "Minuman Energen",
    price: 3.000,
    image01: product_02_image_10,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },
  {
    id: "21",
    title: "Minuman Jahe",
    price: 3.000,
    image01: product_02_image_11,
    category: "Drink",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque. ",
  },

  {
    id: "22",
    title: "Kroket (Isi 2)",
    price: 5.000,
    image01: product_06_image_01,
    category: "Snack",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque.",
  },

  {
    id: "23",
    title: "Lumpia (Isi 3) ",
    price: 5.000,
    image01: product_06_image_02,
    category: "Snack",

    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta ad et est, fugiat repudiandae neque illo delectus commodi magnam explicabo autem voluptates eaque velit vero facere mollitia. Placeat rem, molestiae error obcaecati enim doloribus impedit aliquam, maiores qui minus neque.",
  },
];

export default products;
